import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=1c02a9c9&scoped=true"
import script from "./MarketList.vue?vue&type=script&lang=js"
export * from "./MarketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c02a9c9",
  null
  
)

export default component.exports